<template>
  <div>
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler">
            新增
          </el-button>
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
          >
            删除
          </el-button>
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @edit-closed="closeEditTableHandler"
    >
    </vxe-grid>
  </div>
</template>

<script>
  import { tableRules } from './index';
  import InputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    name: 'SettlementDetail',
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        tableRules,
        isHiddenBtn: false,
        tableData: [],
        selectionList: [],
        editConfig: {},
        ids: [], // 被删除的数据id集合
      };
    },
    computed: {
      settlementEntityList() {
        const list = [];
        const { pledgeeNo, pledgeeName, pledgorNo, pledgorName, relatedNo, relatedName } =
          this.detail;
        if (pledgeeNo && pledgeeName) {
          list.push({
            value: pledgeeNo,
            label: pledgeeName,
          });
        }
        if (pledgorNo && pledgorName) {
          list.push({
            value: pledgorNo,
            label: pledgorName,
          });
        }
        if (relatedNo && relatedName) {
          list.push({
            value: relatedNo,
            label: relatedName,
          });
        }
        return list;
      },
      filledDataList() {
        return this.$refs.xTableRef?.getTableData().fullData || [];
      },
      settlementEntityListOptions() {
        const selectedSettlementList = this.filledDataList.map((v) => v.settlementEntityNo);
        return this.settlementEntityList.filter((v) => !selectedSettlementList.includes(v.value));
      },
      tableColumnsList() {
        return [
          {
            type: 'checkbox',
            width: '50',
          },
          {
            title: '序号',
            type: 'seq',
            width: '50',
          },
          {
            field: 'expenseName',
            title: '费用类型',
            width: '120',
          },
          {
            field: 'settlementEntityName',
            title: '结算主体',
            width: '200',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
            },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {row['settlementEntityNo']
                      ? this.settlementEntityList?.find(
                          (item) => item.value == row['settlementEntityNo']
                        )?.label
                      : ''}
                  </span>,
                ];
              },
              // onChange={(val) => this.expenseStandard(row, val, 'expenseStandard')}
              edit: ({ row }) => {
                return [
                  <el-select
                    value={row['settlementEntityName']}
                    clearable={true}
                    onChange={(val) => this.changeSettlement(val, row, 'settlementEntityNo')}
                  >
                    {this.settlementEntityListOptions?.map((item) => (
                      <ElOption value={item.value} label={item.label}></ElOption>
                    ))}
                  </el-select>,
                ];
              },
            },
          },
          {
            field: 'settlementRate',
            title: '结算比例',
            width: '280',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['settlementRate'] ? row['settlementRate'] + '%' : ''}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row.settlementRate}
                    max={100}
                    min={0}
                    precision={2}
                    // disabled={this.disabledServiceCycle}
                    onBlur={() => this.checkTable()}
                    onInput={(val) => this.changeSettlement(val, row, 'settlementRate')}
                  ></InputNumberAd>,
                ];
              },
            },
          },
        ];
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
    methods: {
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt(
          {
            expenseName: '监管费',
            expenseType: '01',
            settlementEntityNo: null,
            settlementEntityName: null,
            settlementRate: null,
          },
          0
        );
        await $table.setActiveRow(row);
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
      handleSelectionChange(data) {
        this.selectionList = data.selection;
      },
      closeEditTableHandler() {},
      changeSettlement(val, row, type) {
        row[type] = val;
        if (type == 'settlementEntityNo') {
          row['settlementRate'] = null;
          row['settlementEntityName'] = this.settlementEntityList.find(
            (v) => v.value == val
          )?.label;
        }
      },
      checkTable() {
        const data = this.getTableData();
        const total = data.reduce((pre, cur) => {
          return pre + Number(cur.settlementRate || 0);
        }, 0);
        if (total > 100) {
          this.$message.error('结算比例总和不能超过100%');
        }
      },
      getValidateTableData() {
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            if (valid) {
              if (tableData.length) {
                const total = tableData.reduce((pre, cur) => {
                  return pre + Number(cur.settlementRate || 0);
                }, 0);
                if (total != 100) {
                  this.$message.error('结算比例总和须等于100%');
                  reject();
                } else {
                  resolve({ tableData: tableData, deleteSettlementDetailIds: this.ids });
                }
              } else {
                resolve({ tableData: [], deleteSettlementDetailIds: this.ids });
              }
            } else {
              this.$message.error('请检查结算明细填写');
              reject();
            }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
